import gql from "graphql-tag";

const MODAL_QUERY = gql`
  query ModalQuery {
    modal @client
  }
`;

export default MODAL_QUERY;